import * as React from "react";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { useCommonHooks, useEditRouteParams } from "../../../hooks";
import { useQuery } from "react-query";

import { ERoutes } from "../../../AppRouter";
import { BackButton, PageBase } from "../../../components";
import FormQuestionDetailPanel from "./FormQuestionDetailPanel";

export interface FormQuestionItemPageProps {}

export const FormQuestionItemPage: React.FunctionComponent<
  FormQuestionItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["form-question-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.formQuestions.getDisplayName(+id);
      }
      return t("NewFormQuestion");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("FormQuestions"), route: ERoutes.formQuestions },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.formQuestions}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.formQuestions} />
        <Tab
          id="details"
          title={t("Details")}
          panel={<FormQuestionDetailPanel formQuestionId={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};

export default FormQuestionItemPage;
